// extracted by mini-css-extract-plugin
export default {"job-apply_form":"CareerForm_job-apply_form__E3sxP","input-field":"CareerForm_input-field__bcqJv","passout":"CareerForm_passout__64VJg","btn":"CareerForm_btn__bVzMH"};